/**
 * QuotaModalProvider — one mounted QuotaExceededModal for the whole app.
 *
 * Call sites that receive an allowance 429 hand the response detail
 * ({ resource, used, limit, resets, upgrade_to, plan_label }) to
 * showQuotaModal(detail) instead of composing their own toast. The modal
 * variant (upgrade / wait / close-a-slot) derives from the detail itself.
 */

import React, { createContext, useCallback, useContext, useState } from 'react';
import QuotaExceededModal from './QuotaExceededModal';

const QuotaModalContext = createContext(null);

export function useQuotaModal() {
  const show = useContext(QuotaModalContext);
  if (!show) {
    throw new Error('useQuotaModal must be used within QuotaModalProvider');
  }
  return show;
}

export function QuotaModalProvider({ children }) {
  const [detail, setDetail] = useState(null);
  const show = useCallback((d) => setDetail(d || {}), []);

  return (
    <QuotaModalContext.Provider value={show}>
      {children}
      {detail && (
        <QuotaExceededModal
          resource={detail.resource}
          usage={detail}
          onClose={() => setDetail(null)}
        />
      )}
    </QuotaModalContext.Provider>
  );
}
